// src/features/payment/payment.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentState } from './payment.types';

const initialState: PaymentState = {
  lastPayment: undefined,
  status: 'idle',
  error: null
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    payStripePending(state) {
      state.status = 'pending';
      state.error = null;
    },
    payStripeSuccess(state, action: PayloadAction<any>) {
      state.status = 'success';
      state.lastPayment = action.payload;
      state.error = null;
    },
    payStripeError(state, action: PayloadAction<any>) {
      state.status = 'error';
      state.error = action.payload;
    },
    resetPayment(state) {
      state.lastPayment = undefined;
      state.status = 'idle';
      state.error = null;
    }
  }
});

export const { payStripePending, payStripeSuccess, payStripeError, resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
